<template>
  <div class="container">
    <component 
      :is="video"
      :canPlay="canPlayVideo"
      :isReady="isOrderReady"></component>
    <!-- <app-video
      :canPlay="canPlayVideo"
      :isReady="isOrderReady"></app-video> -->
    <section
      v-if="!apiError && dataLoaded"
      class="body-container scrollable">
      <div class="container content-body-container">
        <app-order-info 
          :orderNumber="this.order.number" 
          :isReady="this.isOrderReady"></app-order-info>
        <app-order-status :isReady="isOrderReady"></app-order-status>
        <app-tasks :tasks="this.order.tasks"></app-tasks>
      </div>
      <transition name="flip" mode="out-in">
        <app-refresh 
          v-if="!this.isOrderReady" 
          @refresh-button-clicked="refresh" 
          :animated="isLoading"></app-refresh>
        <app-scan-another-code v-else></app-scan-another-code>
      </transition>
    </section>
    <section v-if="apiError && dataLoaded" class="container body-container">
      <app-error :error="error" :apiError="apiError"></app-error>
    </section>
    <section class="waiting-container" v-if="!dataLoaded">
      <div>
        <i class="waiting fas fa-cookie"></i>
        <p>Loading ...</p>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from '../components/shared/Banner.vue'
import Error from '../components/shared/Error.vue'
import OrderInfo from '../components/order/OrderInfo.vue'
import OrderStatus from '../components/order/OrderStatus.vue'
import Tasks from '../components/task/Tasks.vue'
import Refresh from '../components/buttons/Refresh.vue'
import ScanAnotherCode from '../components/buttons/ScanAnotherCode.vue'
import Axios from 'axios'
import Video from '../components/shared/Video.vue'

export default {
  data () {
    return {
      dataLoaded: false,
      isLoading: false,
      order: {},
      error: null,
      apiError: null,
      awaitingVideo: '/src/assets/video/buzzer_mobile_video_min.mp4',
      readyVideo: '/src/assets/video/buzzer_order_ready_min.mp4',
      canPlayVideo: false,
      readyTasksCount: 0,
      video: 'app-video'
    }
  },
  methods: {
    getOrder () {
      const token =  this.$store.getters.getToken
      if (!token) {
        return
      }
      const orderId = this.$route.params.orderId
      const config = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
      return Axios.get('https://easystore-ws2.modullo.net/api/v2/Sales/Buzzer/' + orderId, config)
      // return Axios.get('https://easystore-dev.modullo.net/api/v2/Sales/Buzzer/' + orderId, config)
        .then(response => {
          this.order = response.data
          this.error = null
          this.apiError = null
          this.dataLoaded = true
        }).catch(error => {
          console.log(error)
          this.apiError = error
          this.dataLoaded = true
          this.isLoading = false
        })
    },
    refresh () {
      if (this.isLoading || this.apiError) {
        return
      }
      this.isLoading = true
      this.getOrder().then(() =>
        setTimeout(() => {
          this.isLoading = false
        }, 2000)
      )
    },
    checkTasks () {
      const oldReadyTasks = this.readyTasksCount
      this.readyTasksCount = this.order.tasks 
        ? this.order.tasks.filter((task) => task.task_status_name_fr === 'Prêt').length
        : 0
      if (oldReadyTasks < this.readyTasksCount && this.readyTasksCount >= 1) {
        this.vibrate()
        this.animateVideo()
      }
    },
    animateVideo () {
      this.canPlayVideo = true
      setTimeout(() => {
        this.canPlayVideo = false
      }, 5000)
    },
    vibrate () {
      navigator.vibrate([200, 200, 200, 200, 200])
    }
  },
  computed: {
    isOrderReady () {
      const isReady = this.order.tasks
        ? this.readyTasksCount == this.order.tasks.length
        : false
      if (isReady) {
        this.canPlayVideo = true
      }
      return isReady
    },
    bannerVideo () {
      const filename = this.isOrderReady ? this.readyVideo : this.awaitingVideo
      return filename
    }
  },
  watch: {
    order () {
      this.checkTasks()
    }
  },
  created () {
    this.$store.dispatch('getToken').then(() => {
      this.getOrder().then(() => {
        const interval = setInterval(() => {
          if (this.isOrderReady) {
            clearInterval(interval)
            return
          }
          this.refresh()
        }, 10000)
        this.animateVideo()
      }).catch(error => {
        console.log(error)
        this.error = 'Get data error'
        this.apiError = error + ''
        this.isLoading = false
        this.dataLoaded = true
      })
    }).catch(error => {
      console.log(error)
      this.error = 'Authentication error'
      this.apiError = error + ''
      this.isLoading = false
      this.dataLoaded = true
    })
  },
  components: {
    appBanner: Banner,
    appError: Error,
    appOrderInfo: OrderInfo,
    appOrderStatus: OrderStatus,
    appTasks: Tasks,
    appRefresh: Refresh,
    appScanAnotherCode: ScanAnotherCode,
    appVideo: Video
  }
}
</script>

<style lang="scss" scoped>
  .content-body-container {
    padding: 10px 0;
  }

  .scrollable {
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch !important;
    // height: calc(-webkit-fill-available - (100% / 2.2));
  }

  .waiting-container {
    position: relative;
    height: 80%;
    width: 100%;

    div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
    }

    .waiting {
      font-size: 75px;
      color: #e0a968;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      border: 1px solid lightcyan;
      box-shadow: 0px 0px 10px 1px rgb(116, 116, 116);
      animation: rotate 1.5s linear infinite;
      -webkit-animation: rotate 1.5s linear infinite;
    }
  }

  .flip-enter-active {
    animation: flip-in .3s linear forwards;
    -webkit-animation: flip-in .3s linear forwards;
  }

  .flip-leave-active {
    animation: flip-out .3s linear forwards;
    -webkit-animation: flip-out .3s linear forwards;
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes flip-out {
    from {
      transform: rotateY(0deg);
      -webkit-transform: rotateY(0deg);
    }
    to {
      transform: rotateY(90deg);
      -webkit-transform: rotateY(90deg);
    }
  }

  @keyframes flip-in {
    from {
      transform: rotateY(90deg);
      -webkit-transform: rotateY(90deg);
    }
    to {
      transform: rotateY(0deg);
      -webkit-transform: rotateY(0deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Order.vue